import Wix from '../services/wix-sdk-polyfill';

export const closeWixModal = action => () => Wix.closeWindow(action);
